import {
    APP_WEBHOOK_GET_REQUEST,
    APP_WEBHOOK_GET_SUCCESS,
    APP_WEBHOOK_GET_FAIL,
    APP_WEBHOOK_UPDATE_REQUEST,
    APP_WEBHOOK_UPDATE_SUCCESS,
    APP_WEBHOOK_UPDATE_FAIL,
    APP_WEBHOOK_UPDATE_RESET,
    APP_WEBHOOK_ROTATE_REQUEST,
    APP_WEBHOOK_ROTATE_SUCCESS,
    APP_WEBHOOK_ROTATE_FAIL,
    APP_WEBHOOK_ROTATE_RESET,
    APP_WEBHOOK_DELIVERIES_REQUEST,
    APP_WEBHOOK_DELIVERIES_SUCCESS,
    APP_WEBHOOK_DELIVERIES_FAIL,
} from "../constants/AppWebhookConstants";

export const appWebhookReducer = (state = { config: null }, action) => {
    switch (action.type) {
        case APP_WEBHOOK_GET_REQUEST:
            return { ...state, loading: true };
        case APP_WEBHOOK_GET_SUCCESS:
            return { loading: false, config: action.payload };
        case APP_WEBHOOK_GET_FAIL:
            return { loading: false, config: null, error: action.payload };
        default:
            return state;
    }
};

export const appWebhookUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case APP_WEBHOOK_UPDATE_REQUEST:
            return { loading: true };
        case APP_WEBHOOK_UPDATE_SUCCESS:
            return { loading: false, success: true };
        case APP_WEBHOOK_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case APP_WEBHOOK_UPDATE_RESET:
            return {};
        default:
            return state;
    }
};

export const appWebhookRotateReducer = (state = {}, action) => {
    switch (action.type) {
        case APP_WEBHOOK_ROTATE_REQUEST:
            return { loading: true };
        case APP_WEBHOOK_ROTATE_SUCCESS:
            return { loading: false, success: true, plaintextSecret: action.payload };
        case APP_WEBHOOK_ROTATE_FAIL:
            return { loading: false, error: action.payload };
        case APP_WEBHOOK_ROTATE_RESET:
            return {};
        default:
            return state;
    }
};

export const appWebhookDeliveriesReducer = (state = { deliveries: [] }, action) => {
    switch (action.type) {
        case APP_WEBHOOK_DELIVERIES_REQUEST:
            return { ...state, loading: true };
        case APP_WEBHOOK_DELIVERIES_SUCCESS:
            return { loading: false, deliveries: action.payload };
        case APP_WEBHOOK_DELIVERIES_FAIL:
            return { loading: false, deliveries: [], error: action.payload };
        default:
            return state;
    }
};
